import { ChangeEvent, FC } from 'react'

import {
  TableContainerStyled,
  TableBodyStyled,
  TableCellStyled,
  TableFooter,
  TableHeadStyled,
  TableRowStyled,
  TableStyled,
  Row,
  Copy
} from 'components'
import { DownloadIcon, StatusIcon, ViewFileIcon } from 'components/Icons'
import { Link } from 'components/Link/Link'
import { IViewAndDownloadProps } from 'hooks/useFile'
import moment from 'moment'
import { IWorkingDocumetationResponse } from 'services/NGT/WorkingDocumentation'
import { COLORS, FORMAT, SPACING } from 'utils'

interface ITableSearchDocumentationProps {
  selectedContractInfo: (contractId: number) => void
  tableData: IWorkingDocumetationResponse[]
  page: number
  areDatesValid: () => boolean
  rowsPerPage: number
  pageCount: number
  handleChangePage: (page: number) => void
  handleViewDocument: (gedExternalId: number) => void
  downloadFile: (gedExternalId: IViewAndDownloadProps) => void
  handleChangeRowsPerPage: (
    row: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void
}

const TableSearchDocumentation: FC<ITableSearchDocumentationProps> = ({
  tableData,
  page,
  rowsPerPage,
  areDatesValid,
  selectedContractInfo,
  pageCount,
  handleChangePage,
  handleChangeRowsPerPage,
  downloadFile,
  handleViewDocument
}) => {
  return (
    <>
      <TableContainerStyled>
        <TableStyled>
          <TableHeadStyled>
            <TableRowStyled>
              <TableCellStyled></TableCellStyled>
              <TableCellStyled>Contrato</TableCellStyled>
              <TableCellStyled align="left">Fornecedor</TableCellStyled>
              <TableCellStyled align="left">Competência</TableCellStyled>
              <TableCellStyled align="left">Tipo Documento</TableCellStyled>
              <TableCellStyled align="left">Data Anexo</TableCellStyled>
              <TableCellStyled align="left">Status</TableCellStyled>
              <TableCellStyled align="left">Ações</TableCellStyled>
            </TableRowStyled>
          </TableHeadStyled>
          <TableBodyStyled>
            {tableData?.map((row, index) => (
              <TableRowStyled key={index}>
                <TableCellStyled align="left">
                  <Copy
                    valueToCopy={row.cdContrato}
                    title="Copiar código de contrato"
                  />
                </TableCellStyled>
                <TableCellStyled align="left">
                  <Link
                    onClick={() => selectedContractInfo(row.contratoId)}
                    color={COLORS.blueFonts}
                  >
                    {row.cdContrato}
                  </Link>
                </TableCellStyled>
                <TableCellStyled align="left">
                  {row.nmFornecedor}
                </TableCellStyled>
                <TableCellStyled align="left">
                  {FORMAT.formatMMYYYY(row.competencia)}
                </TableCellStyled>
                <TableCellStyled align="left">
                  {row.nmTipoDocumento}
                </TableCellStyled>
                <TableCellStyled align="left">
                  {moment(row.dtAnexo).format('YYYY') === '0001'
                    ? '- - - - -'
                    : moment(row.dtAnexo).format('DD/MM/YYYY')}
                </TableCellStyled>
                <TableCellStyled maxwidth="20px" align="right">
                  <StatusIcon
                    value={row.statusColor}
                    marginLeft={SPACING.spacing15}
                  />
                </TableCellStyled>
                <TableCellStyled align="center">
                  <Row alignItems="center" justifyContent="space-evenly">
                    <ViewFileIcon
                      disabled={row.cdGedIdExterno === null}
                      cursor="pointer"
                      onClick={() =>
                        handleViewDocument(parseInt(row.cdGedIdExterno))
                      }
                    />
                    <DownloadIcon
                      disabled={row.cdGedIdExterno === null}
                      cursor="pointer"
                      onClick={() => {
                        downloadFile({
                          gedExternalID: parseInt(row.cdGedIdExterno)
                        })
                      }}
                    />
                  </Row>
                </TableCellStyled>
              </TableRowStyled>
            ))}
          </TableBodyStyled>
        </TableStyled>
      </TableContainerStyled>
      <TableFooter
        page={page - 1}
        //rows={tableData}
        totalItems={pageCount}
        disabled={!areDatesValid()}
        rowsPerPage={rowsPerPage}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        typeFooter="offline"
      />
    </>
  )
}

export default TableSearchDocumentation
